import { Link } from 'react-router-dom';
import Logo from './Logo';
import { navLinks } from '../data/site';

function Footer() {
  return (
    <footer className="bg-ink text-white">
      <div className="wrap grid gap-12 py-20 md:grid-cols-[1.4fr_1fr_1fr]">
        <div>
          <Logo light />
          <p className="mt-6 max-w-sm text-sm leading-7 text-white/60">
            Brick paver design and installation for driveways, patios, pool decks and walkways. Built to make an
            impression, and to last.
          </p>
        </div>
        <div>
          <p className="eyebrow !text-clay">Explore</p>
          <ul className="mt-5 space-y-3 text-sm text-white/75">
            {navLinks.map((l) => (
              <li key={l.to}>
                <Link className="transition hover:text-clay" to={l.to}>
                  {l.label}
                </Link>
              </li>
            ))}
            <li>
              <Link className="transition hover:text-clay" to="/contact">
                Contact
              </Link>
            </li>
          </ul>
        </div>
        <div>
          <p className="eyebrow !text-clay">Start your project</p>
          <p className="mt-5 text-sm leading-7 text-white/65">
            Tell us about your space and we will help you shape the right plan.
          </p>
          <Link to="/contact" className="btn btn-brick mt-6">
            Request a Quote
          </Link>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="wrap flex flex-col justify-between gap-2 py-6 text-xs text-white/45 sm:flex-row">
          <span>© {new Date().getFullYear()} US Paver Co. All rights reserved.</span>
          <span>Gallery imagery is design inspiration, not completed US Paver Co. projects.</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
